import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './LoadingIndicator.scss';

export const LoadingIndicator = ({ className }) => {
  const containerClasses = classnames('efix-loading-indicator', {
    [`${className}`]: !!className,
  });
  const svgWrapperClasses = classnames('efix-loading-indicator__svg-wrapper', {
    [`${className}__svg-wrapper`]: !!className,
  });

  return (
    <div className={containerClasses}>
      <CircularProgress className={svgWrapperClasses} />
    </div>
  );
};
LoadingIndicator.propTypes = {
  className: PropTypes.string,
};
LoadingIndicator.defaultProps = {
  className: '',
};
